// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__rDY7y","inputWrap":"Table_inputWrap__3OqQy","col":"Table_col__1UTU0","bmiTooltip":"Table_bmiTooltip__FBcTw"};